export default "__VITE_ASSET__DjMj$k6Z__"